export default {
  namespaced: true,
  state: {
    innerWH: {
      innerWidth: "",
      innerHeight: ""
    },
    availWH: {
      availWidth: "",
      availHeight: ""
    },
    mainH:"",
  },
  actions: {
    /* */
  },
  getters: {

  },
  mutations: {
    SETINNERWH(state, values) {
      state.innerWH = values;
    },
    SETAVAILWH(state, values) {
      state.availWH = values;
    },
    SETMAINh(state, values) {
      state.mainH = values;
      // console.log("vuex里面修改总大小", state, values);
    },
  }
};
